<div [@.disabled]="isAnimationDisabled"
  [@slideInOutAnimation]="{value:panelState, params:{maxWidth: maxAnimationWidth}}"
  (@slideInOutAnimation.done)="animationDone()" id="context-panel-main" [style.width.px]="panelWidth">
  <div [@fadeInOutAnimation]="panelState" style="height: 100%;">
    <div *inRole="[roles.StandardFeatureSet, roles.DocReviewFeatureSet]" class="context-panel-top-container"
      [matMenuTriggerFor]="contextPanelMenu"
      style="cursor: pointer;display: flex; justify-content: space-between; align-items: center; height: 50px; padding: 0 15px;">
      <div class="context-panel-title-container"
        style="display: flex; justify-content: left; align-items: center; gap: 5px;">
        <div [ngSwitch]="currentPanel$ | async">
          <div *ngSwitchCase="'browse'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-files reviewed-documents-title-header"></div>
            </div>
            <div>
              Browse Documents
            </div>
          </div>
          <div *ngSwitchCase="'exact-dup'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-clone reviewed-documents-title-header"></div>
            </div>
            <div>
              Exact Duplicates (Top 25)
            </div>
          </div>
          <div *ngSwitchCase="'near-dup'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-tablets reviewed-documents-title-header"></div>
            </div>
            <div>
              Near Duplicates (Top 25)
            </div>
          </div>
          <div *ngSwitchCase="'email-families'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-envelopes reviewed-documents-title-header"></div>
            </div>
            <div>
              Email Family
            </div>
          </div>
          <div *ngSwitchCase="'email-threading'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-code-pull-request reviewed-documents-title-header"></div>
            </div>
            <div>
              Email Threading
            </div>
          </div>
          <div *ngSwitchCase="'review'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-history reviewed-documents-title-header"></div>
            </div>
            <div>
              Review Documents
            </div>
          </div>
          <div *ngSwitchCase="'split-sub'" style="display: flex;">
            <div class="context-panel-icon">
              <div class="fa-duotone fa-hand-scissors reviewed-documents-title-header"></div>
            </div>
            <div>
              Extracted Pages
            </div>
          </div>
        </div>
      </div>
      <div class="context-panel-icon context-panel-expand-icon">
        <div class="fas fa-chevron-down"></div>
      </div>
      <mat-menu class="doc-viewer-menu" #contextPanelMenu yPosition="below">
        <div>
          <menu mat-menu-item *ngIf="(shouldShowReviewContextPanel$ | async) === false">
            <div [style.width.px]="panelWidth - 32" (click)="changeListView('browse')"
              class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-files reviewed-documents-title-header"></div>
              </div>
              <div>Browse Documents</div>
            </div>
          </menu>
          <menu mat-menu-item *ngIf="(shouldShowReviewContextPanel$ | async)">
            <div [style.width.px]="panelWidth - 32" (click)="changeListView('review')"
              class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-history reviewed-documents-title-header"></div>
              </div>
              <div>Reviewed Documents</div>
            </div>
          </menu>
          <menu mat-menu-item>
            <div (click)="changeListView('exact-dup')" class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-clone reviewed-documents-title-header"></div>
              </div>
              <div>Exact Duplicates (Top 25)</div>
            </div>
          </menu>
          <menu mat-menu-item>
            <div (click)="changeListView('near-dup')" class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-tablets reviewed-documents-title-header"></div>
              </div>
              <div>Near Duplicates (Top 25)</div>
            </div>
          </menu>
          <menu mat-menu-item>
            <div (click)="changeListView('email-families')" class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-envelopes reviewed-documents-title-header"></div>
              </div>
              <div>Email Family</div>
            </div>
          </menu>
          <menu mat-menu-item>
            <div (click)="changeListView('email-threading')" class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-code-pull-request reviewed-documents-title-header"></div>
              </div>
              <div>Email Threading</div>
            </div>
          </menu>
          <menu mat-menu-item>
            <div (click)="changeListView('split-sub')" class="context-panel-title-container"
              style="display: flex; justify-content: left; align-items: center; gap: 5px;">
              <div class="context-panel-icon">
                <div class="fa-duotone fa-hand-scissors reviewed-documents-title-header"></div>
              </div>
              <div>Extracted Pages</div>
            </div>
          </menu>
        </div>
      </mat-menu>
    </div>
    <div *inRole="[roles.LimitedFeatureSet]" class="context-panel-top-container" [matMenuTriggerFor]="contextPanelMenu"
      style="cursor: pointer;display: flex; justify-content: space-between; align-items: center; height: 50px; padding: 0 15px;">
      <div style="display: flex;">
        <div class="context-panel-icon">
          <div class="fa-duotone fa-files reviewed-documents-title-header"></div>
        </div>
        <div>
          Browse Documents
        </div>
      </div>
    </div>
    <div [ngSwitch]="currentPanel$ | async" class="context-panel-body-container"
      style="overflow: auto; height: calc(100% - 106px);">
      <lex-browse-context-panel *ngSwitchCase="'browse'"></lex-browse-context-panel>
      <lex-review-context-panel *ngSwitchCase="'review'"></lex-review-context-panel>
      <lex-exact-duplicate-context-panel *ngSwitchCase="'exact-dup'"></lex-exact-duplicate-context-panel>
      <lex-near-duplicate-context-panel *ngSwitchCase="'near-dup'"></lex-near-duplicate-context-panel>
      <lex-email-family-context-panel *ngSwitchCase="'email-families'"></lex-email-family-context-panel>
      <lex-email-threading-context-panel *ngSwitchCase="'email-threading'"></lex-email-threading-context-panel>
      <lex-split-sub-panel *ngSwitchCase="'split-sub'"></lex-split-sub-panel>
    </div>
  </div>
  <div id="context-panel-toggle" (click)="toggle()">
    <div [@rotateAnimation]="panelState" class="fa-duotone fa-chevrons-left toggle-arrow"></div>
  </div>
</div>